"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _aggregatorStyles = require("./aggregatorStyles");
var _lodash = require("lodash");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const AggregatorItem = (0, _react.forwardRef)((props, ref) => {
  const {
    image,
    title,
    subtitle,
    cta,
    url,
    titleMinHeight
  } = props;
  const fluid = image?.fluid || image?.responsiveImage || image;
  return _react.default.createElement(_aggregatorStyles.AggregatorWrapper, {
    aspectRatio: fluid.aspectRatio
  }, _react.default.createElement(_aggregatorStyles.AggregatorContent, null, _react.default.createElement(_aggregatorStyles.BackgroundImage, {
    image: fluid.src,
    className: "aa-bg-img"
  }), _react.default.createElement(_aggregatorStyles.Overlay, {
    className: "aa-overlay"
  }), _react.default.createElement(_aggregatorStyles.AggregatorLink, {
    href: url,
    className: "article-aggregator"
  }, _react.default.createElement(_aggregatorStyles.AggregatorInfo, null, _react.default.createElement(_aggregatorStyles.AggregatorTitle, {
    ref: ref,
    className: "article-aggregator",
    minHeight: titleMinHeight
  }, title), _react.default.createElement(_aggregatorStyles.AggregatorSubtitle, {
    className: "article-aggregator"
  }, subtitle), _react.default.createElement(_aggregatorStyles.AggregatorCTA, null, _react.default.createElement("p", {
    className: "article-aggregator-cta"
  }, cta))))));
});
const Aggregator = ({
  articleAggregatorItems
}) => {
  const containerRef = (0, _react.useRef)(null);
  const [minHeight, setMinHeight] = (0, _react.useState)(null);
  const itemTitlesRefs = (0, _react.useRef)([]);
  itemTitlesRefs.current = Array(articleAggregatorItems.length).fill().map((_, i) => itemTitlesRefs[i] || (0, _react.createRef)());
  (0, _react.useEffect)(() => {
    let _minHeight = 0;
    (0, _lodash.forEach)(itemTitlesRefs.current, item => {
      if (item.current.offsetHeight > _minHeight) {
        _minHeight = item.current.offsetHeight;
      }
    });
    setMinHeight(_minHeight);
  }, []);
  return _react.default.createElement(_aggregatorStyles.ContainerDiv, {
    ref: containerRef
  }, articleAggregatorItems?.map((item, i) => {
    return _react.default.createElement(AggregatorItem, {
      key: `aggregator-item--${i}`,
      ref: itemTitlesRefs.current[i],
      titleMinHeight: minHeight,
      image: item.image,
      title: item.title,
      subtitle: item.subtitle,
      cta: item.cta,
      url: item.url
    });
  }));
};
var _default = Aggregator;
exports.default = _default;
//# sourceMappingURL=ArticleAggregator.js.map